function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 9C1 8.44772 1.44772 8 2 8H7C7.55228 8 8 8.44772 8 9V20C8 20.5523 7.55228 21 7 21H2C1.44772 21 1 20.5523 1 20V9Z",
  fill: "#D928DC"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 2.55325C11 2.22426 11.2883 1.96972 11.6148 2.01053L12.5852 2.13183C14.536 2.37569 16 4.03405 16 6.00007V8.00007H18.5722C20.8801 8.00007 22.5561 10.1945 21.9489 12.421L20.5853 17.421C20.17 18.9437 18.7869 20.0001 17.2086 20.0001H10C9.90129 20.0001 9.80478 19.9709 9.72265 19.9161L9.22265 19.5828C9.08355 19.49 9 19.3339 9 19.1667V9.16674C9 9.05856 9.03509 8.95329 9.1 8.86674L11 6.33341V2.55325Z",
  fill: "#D928DC"
});

var SvgLikeactive = function SvgLikeactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLikeactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/likeactive.5de1e232.svg";
export { ForwardRef as ReactComponent };